export const LOAD_CREATE_OPERATION_DATA = 'OPERATION/LOAD_CREATE_OPERATION_DATA';

export const CREATE_OPERATION_DATA_LOADED = 'OPERATION/LOAD_DATA_SUCCESS';
export const CREATE_OPERATION_DATA_ERROR = 'OPERATION/LOAD_DATA_ERROR';

export const DELETE_OPERATION = 'OPERATION/DELETE_OPERATION';
export const DELETE_OPERATION_SUCCESS = 'OPERATION/DELETE_OPERATION_SUCCESS';

export const QUOTE_OPERATION = 'OPERATION/QUOTE_OPERATION';
export const QUOTE_OPERATION_SUCCESS = 'OPERATION/QUOTE_OPERATION_SUCCESS';
export const QUOTE_OPERATION_ERROR = 'OPERATION/QUOTE_OPERATION_ERROR';
export const UPDATE_QUOTE_OPERATION = 'OPERATION/UPDATE_QUOTE_OPERATION';

export const UPDATE_PRICE_QUOTE_OPERATION = 'OPERATION/UPDATE_PRICE_QUOTE_OPERATION';
export const UPDATE_VALUES_QUOTE_OPERATION = 'OPERATION/UPDATE_VALUES_QUOTE_OPERATION';

export const SAVE_OPERATION = 'OPERATION/SAVE_OPERATION';
export const SAVE_OPERATION_SUCCESS = 'OPERATION/SAVE_OPERATION_SUCCESS';
export const SAVE_OPERATION_ERROR = 'OPERATION/SAVE_OPERATION_ERROR';

export const CLEAR_SAVE_OPERATION = 'OPERATION/CLEAR_SAVE_OPERATION';
